import {createLogDB, updateLogBD} from '@/repositories/user.repository';

import UserLogModel from '@/models/userLog.model'

import adminStore from "@/store/admin.store"
import userStore from "@/store/user.store"

import {getDuration} from '@/services/date.service.js'

const admin = adminStore.getters.admin;




export const createLog = async () => {
  const user = userStore.getters.user;

  const userLogModel = new UserLogModel()
  const userLog = userLogModel.getData()
  
  userLog.userCode = user.codigo
  userLog.CNPJ_CNPF = user.CNPJ_CNPF,
  userLog.totemId = admin.selectedTotem.id,
  userLog.useDate =  new Date().toISOString()

  createLogDB(userLog)
}

export const updateLog = async (transactionType) => {
  const userLog = userStore.getters.userLog;


  if (transactionType) {
    userLog[transactionType] = true
    return null;
  }

  const finalDate = new Date().toISOString();
  const serviceTime = getDuration(userLog.useDate, finalDate)

  userLog.serviceTime = serviceTime

  updateLogBD(userLog)


}

export const signOut = async () => {
  updateLog()
}